/**
 * @generated SignedSource<<a12c5ad3dd301918fc90daa668c8ce9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CopyFlightButton_packageDate$data = {
  readonly flight: {
    readonly forwardFlightNumber: string | null;
    readonly returnFlightNumber: string | null;
  } | null;
  readonly id: string;
  readonly " $fragmentType": "CopyFlightButton_packageDate";
};
export type CopyFlightButton_packageDate$key = {
  readonly " $data"?: CopyFlightButton_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"CopyFlightButton_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CopyFlightButton_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "flight",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forwardFlightNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "returnFlightNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "078902822dbf94deecfd18ed1210e94d";

export default node;
